/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner from './OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner';

/**
 * The OrdersCheckoutserviceproductPostRequestServiceItemsInner model module.
 * @module model/OrdersCheckoutserviceproductPostRequestServiceItemsInner
 * @version 1.0.0
 */
class OrdersCheckoutserviceproductPostRequestServiceItemsInner {
    /**
     * Constructs a new <code>OrdersCheckoutserviceproductPostRequestServiceItemsInner</code>.
     * @alias module:model/OrdersCheckoutserviceproductPostRequestServiceItemsInner
     */
    constructor() { 
        
        OrdersCheckoutserviceproductPostRequestServiceItemsInner.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OrdersCheckoutserviceproductPostRequestServiceItemsInner</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrdersCheckoutserviceproductPostRequestServiceItemsInner} obj Optional instance to populate.
     * @return {module:model/OrdersCheckoutserviceproductPostRequestServiceItemsInner} The populated <code>OrdersCheckoutserviceproductPostRequestServiceItemsInner</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrdersCheckoutserviceproductPostRequestServiceItemsInner();

            if (data.hasOwnProperty('basketItemId')) {
                obj['basketItemId'] = ApiClient.convertToType(data['basketItemId'], 'Number');
            }
            if (data.hasOwnProperty('catalogId')) {
                obj['catalogId'] = ApiClient.convertToType(data['catalogId'], 'Number');
            }
            if (data.hasOwnProperty('productId')) {
                obj['productId'] = ApiClient.convertToType(data['productId'], 'Number');
            }
            if (data.hasOwnProperty('subTotal')) {
                obj['subTotal'] = ApiClient.convertToType(data['subTotal'], 'Number');
            }
            if (data.hasOwnProperty('vat')) {
                obj['vat'] = ApiClient.convertToType(data['vat'], 'Number');
            }
            if (data.hasOwnProperty('total')) {
                obj['total'] = ApiClient.convertToType(data['total'], 'Number');
            }
            if (data.hasOwnProperty('currency')) {
                obj['currency'] = ApiClient.convertToType(data['currency'], 'String');
            }
            if (data.hasOwnProperty('unit')) {
                obj['unit'] = ApiClient.convertToType(data['unit'], 'String');
            }
            if (data.hasOwnProperty('category')) {
                obj['category'] = ApiClient.convertToType(data['category'], 'String');
            }
            if (data.hasOwnProperty('extendedData')) {
                obj['extendedData'] = ApiClient.convertToType(data['extendedData'], 'String');
            }
            if (data.hasOwnProperty('extendedDataXml')) {
                obj['extendedDataXml'] = ApiClient.convertToType(data['extendedDataXml'], 'String');
            }
            if (data.hasOwnProperty('effectiveFromDate')) {
                obj['effectiveFromDate'] = ApiClient.convertToType(data['effectiveFromDate'], 'Date');
            }
            if (data.hasOwnProperty('links')) {
                obj['links'] = ApiClient.convertToType(data['links'], [OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner]);
            }
            if (data.hasOwnProperty('accountId')) {
                obj['accountId'] = ApiClient.convertToType(data['accountId'], 'Number');
            }
            if (data.hasOwnProperty('serviceId')) {
                obj['serviceId'] = ApiClient.convertToType(data['serviceId'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>OrdersCheckoutserviceproductPostRequestServiceItemsInner</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>OrdersCheckoutserviceproductPostRequestServiceItemsInner</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
            throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
        }
        // ensure the json data is a string
        if (data['unit'] && !(typeof data['unit'] === 'string' || data['unit'] instanceof String)) {
            throw new Error("Expected the field `unit` to be a primitive type in the JSON string but got " + data['unit']);
        }
        // ensure the json data is a string
        if (data['category'] && !(typeof data['category'] === 'string' || data['category'] instanceof String)) {
            throw new Error("Expected the field `category` to be a primitive type in the JSON string but got " + data['category']);
        }
        // ensure the json data is a string
        if (data['extendedData'] && !(typeof data['extendedData'] === 'string' || data['extendedData'] instanceof String)) {
            throw new Error("Expected the field `extendedData` to be a primitive type in the JSON string but got " + data['extendedData']);
        }
        // ensure the json data is a string
        if (data['extendedDataXml'] && !(typeof data['extendedDataXml'] === 'string' || data['extendedDataXml'] instanceof String)) {
            throw new Error("Expected the field `extendedDataXml` to be a primitive type in the JSON string but got " + data['extendedDataXml']);
        }
        if (data['links']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['links'])) {
                throw new Error("Expected the field `links` to be an array in the JSON data but got " + data['links']);
            }
            // validate the optional field `links` (array)
            for (const item of data['links']) {
                OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} basketItemId
 */
OrdersCheckoutserviceproductPostRequestServiceItemsInner.prototype['basketItemId'] = undefined;

/**
 * @member {Number} catalogId
 */
OrdersCheckoutserviceproductPostRequestServiceItemsInner.prototype['catalogId'] = undefined;

/**
 * @member {Number} productId
 */
OrdersCheckoutserviceproductPostRequestServiceItemsInner.prototype['productId'] = undefined;

/**
 * @member {Number} subTotal
 */
OrdersCheckoutserviceproductPostRequestServiceItemsInner.prototype['subTotal'] = undefined;

/**
 * @member {Number} vat
 */
OrdersCheckoutserviceproductPostRequestServiceItemsInner.prototype['vat'] = undefined;

/**
 * @member {Number} total
 */
OrdersCheckoutserviceproductPostRequestServiceItemsInner.prototype['total'] = undefined;

/**
 * @member {String} currency
 */
OrdersCheckoutserviceproductPostRequestServiceItemsInner.prototype['currency'] = undefined;

/**
 * @member {String} unit
 */
OrdersCheckoutserviceproductPostRequestServiceItemsInner.prototype['unit'] = undefined;

/**
 * @member {String} category
 */
OrdersCheckoutserviceproductPostRequestServiceItemsInner.prototype['category'] = undefined;

/**
 * @member {String} extendedData
 */
OrdersCheckoutserviceproductPostRequestServiceItemsInner.prototype['extendedData'] = undefined;

/**
 * @member {String} extendedDataXml
 */
OrdersCheckoutserviceproductPostRequestServiceItemsInner.prototype['extendedDataXml'] = undefined;

/**
 * @member {Date} effectiveFromDate
 */
OrdersCheckoutserviceproductPostRequestServiceItemsInner.prototype['effectiveFromDate'] = undefined;

/**
 * @member {Array.<module:model/OrdersCheckoutserviceproductPostRequestServiceItemsInnerLinksInner>} links
 */
OrdersCheckoutserviceproductPostRequestServiceItemsInner.prototype['links'] = undefined;

/**
 * @member {Number} accountId
 */
OrdersCheckoutserviceproductPostRequestServiceItemsInner.prototype['accountId'] = undefined;

/**
 * @member {Number} serviceId
 */
OrdersCheckoutserviceproductPostRequestServiceItemsInner.prototype['serviceId'] = undefined;






export default OrdersCheckoutserviceproductPostRequestServiceItemsInner;

